import Cloning from './Cloning';

export default Cloning;
